<template>
    <div class="container">
        <img src="@/assets/home/service.png" alt="" @click="openContactPopup">
    </div>
    <ContactServicePopup ref="contactRef" />
</template>

<script setup lang="ts">
import ContactServicePopup from '@/view/profile/contactServicePopup.vue';
import { ref } from 'vue';
const contactRef = ref()

const openContactPopup = () => {
    contactRef.value.open()
}

</script>
<style scoped>
.container {
    position: fixed;
    bottom: 70px;
    left: 15px;
}

.container img {
    border-radius: 10px;
    width: 60px;
}
</style>